import { Card, CardBody, CardHeader } from "reactstrap";

export const CardUserWallet = ({ wallet }) => {
  if (!wallet) return null;

  return (
    <Card>
      <CardHeader>Billetera</CardHeader>
      <CardBody>
        <p><strong>Fecha de creación:</strong> {new Date(wallet.createdAt).toLocaleString()}</p>
        <p><strong>Historial:</strong> {wallet.history.length} movimientos</p>
      </CardBody>
    </Card>
  );
};
